import {get,post} from "../Api.js";
import config from "../config";
import {getCookie} from '../../untils/common.js'
import axios from 'axios'
const {baseUrl} = config



// 6要素
function ApiGetCategory (params) {
  return get(`${baseUrl}course/category`, params);
}

// 6要素子要素
function ApiGetCategoryChild (params) {
  return post(`${baseUrl}course/categoryCourse`, params);
}

// 重点课程分类
function ApiGetkeyCategory (params) {
  return post(`${baseUrl}course/keyCategory`, params);
}

// 课程详情
function ApiGetdetail (params) {
  return get(`${baseUrl}course/detail`, params);
}
//课程章节
function ApiGetchapter (params) {
  return get(`${baseUrl}course/chapter`, params);
}

// 图书课程分类
function ApiGetBookCategory (params) {
  return get(`${baseUrl}book/category/`, params);
}
// 图书课程列表
function ApiGetBookCourse (params) {
  return get(`${baseUrl}book/course/`, params);
}
// 图书课程详情
function ApiGetBookCourseDetail (params) {
  return get(`${baseUrl}book/course/detail`, params);
}
// 图书课程章节
function ApiGetBookchapter (params) {
  return get(`${baseUrl}book/course/chapter`, params);
}



//客服信息
function ApiGetcustomService (params) {
  return post(`${baseUrl}student/customService`, params);
}


//任务详情
function ApiGettaskTrainDetails (params) {
  return post(`${baseUrl}task/taskTrainDetails`, params);
}

//课程反馈
function ApiFeedback (params) {
  return post(`${baseUrl}course/feedback`, params);
}

//课程收藏 取消收藏
function ApiCollect (params) {
  return post(`${baseUrl}course/collect`, params);
}

//课程喜欢 取消喜欢
function ApiLike (params) {
  return post(`${baseUrl}course/like`, params);
}

//任务排名
function ApiGettaskRank (params) {
  return post(`${baseUrl}task/taskProgressRank`, params);
}

//任务统计
function ApiGettaskSum (params) {
  return post(`${baseUrl}task/taskSum`, params);
}

//直播列表
function ApiGetlivelist (params) {
  return post(`${baseUrl}live/list`, params);
}

//查询课件最新状态 ( 是否可以学习)
function ApiGetlessonStatus (params) {
  return get(`${baseUrl}course/lessonStatus`, params);
}

//课程练习
function ApiGetpractice (params) {
  return post(`${baseUrl}course/practice`, params);
}

//课程评分
function ApiPostevaluate (params) {
  return post(`${baseUrl}course/evaluate/evaluate`, params);
}

//获取已选标签
function ApiGetMyLabel (params) {
  return get(`${baseUrl}label/myLabel`, params);
}

//获取已选标签下课程信息
function ApiGetMyLabelCourse (params) {
  return get(`${baseUrl}label/myLabelCourseForPC`, params);
}

//获取获取标签列表
function ApiGetLabel (params) {
  return get(`${baseUrl}label/`, params);
}

//保存已选标签
function ApiSelectedLabel (params) {
  return post(`${baseUrl}label/selectedLabel`, params);
}

export {
  ApiGetCategory,
  ApiGetCategoryChild,
  ApiGetkeyCategory,
  ApiGetdetail,
  ApiGetchapter,
  ApiGetBookCategory,
  ApiGetBookCourse,
  ApiGetBookCourseDetail,
  ApiGetBookchapter,
  ApiGetcustomService,
  ApiGettaskTrainDetails,
  ApiFeedback,
  ApiCollect,
  ApiGettaskRank,
  ApiGettaskSum,
  ApiLike,
  ApiGetlivelist,
  ApiGetlessonStatus,
  ApiGetpractice,
  ApiPostevaluate,
  ApiGetMyLabel,
  ApiGetMyLabelCourse,
  ApiGetLabel,
  ApiSelectedLabel
}



// WEBPACK FOOTER //
// ./src/net/course/index.js